import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getOpenAdvancedSearchDialog, getOpenWorkflowDialog, handleOpenAdvancedSearchDialog, handleOpenWorkflowDialog } from "../../../reducers/uiSlice";
import AdvancedSearch from "../../AdvancedSearch";
import UniDialog from "../../Common/UniDialog";
import WorkflowManagement from "../../WorkflowManagement";

function WorkflowModal(props){

    const {t} = useTranslation('workflowManagement')
    const dispatch = useDispatch();
    let openWorkflowDialog = useSelector(getOpenWorkflowDialog);

    return (
        <UniDialog
            title={t('workflow_management')}
            maxWidth='md'
            fullWidth
            open={openWorkflowDialog}
            onClose={()=>dispatch(handleOpenWorkflowDialog(false))}
            disableDefaultButtons
        >
            <WorkflowManagement open={openWorkflowDialog}/>
        </UniDialog>
    )
}

export default WorkflowModal